
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.184","height":"10.955"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19258","data-name":"Path 19258","d":"M11.229 1H2.955A2.756 2.756 0 000 3.49v5.975a2.756 2.756 0 002.955 2.49h8.274a2.756 2.756 0 002.955-2.49V3.49A2.756 2.756 0 0011.229 1zM2.955 2h8.274a1.8 1.8 0 011.643.94L8.346 6.749a2.02 2.02 0 01-2.508 0L1.312 2.936A1.8 1.8 0 012.955 2zm8.274 8.963H2.955a1.651 1.651 0 01-1.773-1.498V4.237L5 7.453a3.363 3.363 0 004.179 0L13 4.237v5.228a1.651 1.651 0 01-1.771 1.494z","transform":"translate(0 -1)","fill":"#5f6368"}})])
          )
        }
      }
    